
import { BlogSection } from '@/types/blog';

export const menschBleibtSection: BlogSection = {
  id: 'mensch-bleibt',
  title: 'Der Mensch bleibt unersetzlich – aber er muss wachsen',
  content: `
    <p>
      Trotz der beeindruckenden Entwicklung bleibt eines klar: KI ersetzt nicht den Menschen. Sie verändert jedoch die Art, wie wir denken und handeln. Deine Rolle als Entscheider:in wird anspruchsvoller, aber auch spannender:
    </p>

    <h3>Erwerb neuer Kompetenzen:</h3>
    <p>
      Um die Potenziale von KI voll auszuschöpfen, solltest du dich mit ihrer Funktionsweise vertraut machen – sowohl technisch als auch emotional. Je besser du KI verstehst, desto souveräner kannst du sie für deine Ziele einsetzen.
    </p>

    <h3>Ethik und Verantwortung stärken:</h3>
    <p>
      Verantwortungsvoller Einsatz bedeutet nicht nur, Regeln zu befolgen, sondern aktiv mitzugestalten. Du wirst zur wichtigen Instanz, um Innovationen sicher und nachhaltig zu gestalten.
    </p>

    <div class="my-8">
      <img 
        src="/images/blog/team-computer.jpg" 
        alt="Teammitglieder arbeiten gemeinsam an Computern" 
        class="rounded-lg w-full h-auto shadow-md" 
      />
      <p class="text-sm text-left mt-2 text-joerg-600">Menschliche Zusammenarbeit bleibt auch im KI-Zeitalter unverzichtbar</p>
    </div>

    <h3>Nachhaltigkeit und Ressourcenbewusstsein:</h3>
    <p>
      Der Einsatz von KI benötigt Energie und Ressourcen. Daher ist ein bewusster und nachhaltiger Umgang notwendig – ein Thema, das zunehmend auch für Investoren und Verbraucher relevant wird.
    </p>
  `
};
